import axios from 'axios'
import xmlUtils from '@/utils/XmlUtils.vue'
import applicationConstants from '@/constants/ApplicationConstants'
import countriesConstants from '@/constants/CountriesConstants'

export default {
  actions: {
    async claculateCurrencies (ctx, [currency, value]) {
      const data = JSON.stringify({
        ClientAppId: applicationConstants.logInBodyRequest.ClientAppId,
        ClientAppVersion:
        applicationConstants.logInBodyRequest.ClientAppVersion,
        OriginCountry: 'Canada',
        OriginCurrency: 'CAD',
        SendAmountOrigin: +value,
        RemittanceGatewayId: currency.key,
        DestCountry: currency.countryName,
        DestCurrency: currency.code
      })
      const result = await axios.post(
        applicationConstants.publicServerBaseUrl + 'CalculateTransactionFee',
        data,
        {
          crossdomain: true,
          headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
        }
      )
      const response = xmlUtils.methods.getParseObjectFromXml(
        await result.data
      )
      const values = response.CalculateTransactionFeeResponse
      ctx.commit('updateTransactionValues', values, value)
    },
    async fetchCurrencies (ctx) {
      const data = JSON.stringify({
        ClientAppId: applicationConstants.logInBodyRequest.ClientAppId,
        ClientAppVersion: applicationConstants.logInBodyRequest.ClientAppVersion
      })

      const result = await axios.post(
        applicationConstants.publicServerBaseUrl + 'GetRemittanceoptions2',
        data,
        {
          crossdomain: true,
          headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
        }
      )
      const response = xmlUtils.methods.getParseObjectFromXml(
        await result.data
      )
      const currencies =
        response.GetRemittanceOptionsResponse2.RemittanceOptions
          .RemittanceOption2
      ctx.commit('updateCountries', currencies)
    },
    async fetchCurrenciesBy2Code (ctx, currencies) {
      const newCurrency = []
      countriesConstants.currenciesByRemittanceOptions.forEach((currency, i) => {
        const curFind = currencies.find(c => +c.key === i)
        if (curFind) {
          newCurrency.push({
            countryName: countriesConstants.countriesNameBy2Code[curFind.country],
            country: curFind.country,
            name: countriesConstants.currenciesName[curFind.currency],
            code: curFind.currency,
            key: curFind.key,
            enabled: curFind.enabled,
            deliveryMethod: curFind.deliveryMethod,
            deliveryTimeUnit: curFind.deliveryTimeUnit,
            deliveryTimeMax: curFind.deliveryTimeMax,
            deliveryMethodDescription: curFind.deliveryMethodDescription,
            serviceFeeFlat: curFind.serviceFeeFlat,
            remittanceOptionId: curFind.remittanceOptionId
          })
        } else {
          const countryName = Object.entries(countriesConstants.countriesCurrencies).find(([k, c]) => c === currency)
          if (!countryName) {
            newCurrency.push({})
          } else {
            newCurrency.push({
              countryName: countriesConstants.countriesNameBy2Code[countryName[0]],
              country: countryName[0],
              code: currency,
              name: countriesConstants.currenciesName[currency],
              key: i,
              currencyCountries: [],
              remittanceOptionId: i,
              enabled: false
            })
          }
        }
      })
      ctx.commit('updateGlobalCountries', [...newCurrency.filter(
        (set => f => !set.has(f.countryName) && set.add(f.countryName))(new Set())
      )])
      ctx.commit(
        'updateCurrencies',
        [
          ...newCurrency.filter(
            (set => f => !set.has(f.name) && set.add(f.name))(new Set())
          )
        ].map(currency => {
          return newCurrency.reduce((acc, elem) => {
            if (acc.name === elem.name && +elem.enabled) {
              if (!acc.enabled && elem.enabled) {
                const tmp = { ...acc, ...elem }
                elem = {
                  key: acc.key,
                  serviceFeeFlat: acc.serviceFeeFlat,
                  deliveryMethod: acc.deliveryMethod,
                  deliveryMethodDescription: acc.deliveryMethodDescription,
                  deliveryTimeMax: acc.deliveryTimeMax,
                  deliveryTimeUnit: acc.deliveryTimeUnit
                }
                acc = tmp
              }
              if (acc.otherDeliveryMethods === undefined) {
                acc.otherDeliveryMethods = []
              } else {
                acc.otherDeliveryMethods.push({
                  key: elem.key,
                  serviceFeeFlat: elem.serviceFeeFlat,
                  deliveryMethod: elem.deliveryMethod,
                  deliveryMethodDescription: elem.deliveryMethodDescription,
                  deliveryTimeMax: elem.deliveryTimeMax,
                  deliveryTimeUnit: elem.deliveryTimeUnit
                })
                /// TODO: Uncomment if necessary
                // acc.otherDeliveryMethods = acc.otherDeliveryMethods.filter(
                //   (set => f =>
                //     acc.deliveryMethod !== f.deliveryMethod &&
                //     !set.has(f.deliveryMethod) &&
                //     set.add(f.deliveryMethod))(new Set())
                // )
              }
              if (acc.currencyCountries === undefined) {
                acc.currencyCountries = []
              } else {
                acc.currencyCountries.push({
                  ...elem
                })
                acc.currencyCountries = acc.currencyCountries.sort((a, b) => a.deliveryMethod ? a.deliveryMethod.localeCompare(b.deliveryMethod) : null).filter(
                  (set => f =>
                    acc.countryName !== f.countryName &&
                      !set.has(f.countryName) &&
                      set.add(f.countryName))(new Set())
                )
                acc.otherDeliveryMethods = acc.otherDeliveryMethods.sort((a, b) => a.deliveryMethod ? a.deliveryMethod.localeCompare(b.deliveryMethod) : null)
              }
            }
            return acc
          }, currency)
        })
      )
    }
  },
  mutations: {
    updateTransactionValues (state, values, received) {
      state.calculationValues = {
        exchangeRate: 1 / values.ExchangeRate._text,
        xferFee: values.XferFee._text,
        sendAmountDest: values.SendAmountDest._text,
        promoExchangeRate: 1 / values.PromoExchangeRate._text
      }
    },
    updateCountries (state, countries) {
      state.countries = countries.map(country => {
        return {
          currency: country.Currency._text,
          country: country.Country._text,
          countryName: countriesConstants.countriesNameBy2Code[country.Country._text],
          key: country.RemittanceOptionId._text,
          enabled: country.Enabled._text,
          deliveryMethod: country.Category._text,
          deliveryMethodDescription: country.Category._text === country.Description._text ? country.Name._text : country.Description._text,
          deliveryTimeUnit: country.DeliveryTimeUnit._text,
          deliveryTimeMax: country.DeliveryTimeMax._text,
          serviceFeeFlat: country.ServiceFeeFlat._text,
          remittanceOptionId: country.RemittanceOptionId._text,
          name: country.Name._text
        }
      })
      state.avilableRemittanceOptionsIds = countries.map(remittanceOption => {
        return remittanceOption['RemittanceOptionId']._text
      })
    },
    updateGlobalCountries (state, countries) {
      state.globalCountries = countries
    },
    updateCurrencies (state, currencies) {
      const byName = currencies.filter(c => Object.keys(c).length).slice(0)
      byName.sort((a, b) => {
        var x = a.name.toLowerCase()
        var y = b.name.toLowerCase()
        return x < y ? -1 : x > y ? 1 : 0
      }).sort((a, b) => {
        return b.enabled - a.enabled
      })
      state.currencies = byName
      const dropdownPopularCurrencies = localStorage.getItem('dropdown-popular-currencies')
      if (dropdownPopularCurrencies && Array.isArray(JSON.parse(dropdownPopularCurrencies)) && JSON.parse(dropdownPopularCurrencies).length === 4) {
        state.popular_currencies = currencies.filter(v => JSON.parse(dropdownPopularCurrencies).map(cur => cur.countryName).includes(v.countryName))
      } else {
        state.popular_currencies = currencies.filter(v => ['India', 'Philippines', 'Sri Lanka', 'Pakistan'].includes(v.countryName))
      }
    }
  },
  getters: {
    allCurrencies (state) {
      return state.currencies
    },
    popularCurrencies (state) {
      return state.popular_currencies
    },
    allCountries (state) {
      return state.countries
    },
    getCalculationValues (state) {
      return state.calculationValues
    },
    getAllGlobalCountries (state) {
      return state.globalCountries
    },
    getAvailableRemittanceOptionsIds (state) {
      return state.avilableRemittanceOptionsIds
    }
  },
  state: {
    popular_currencies: [],
    calculationValues: {},
    currencies: [],
    countries: [],
    globalCountries: [],
    avilableRemittanceOptionsIds: []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/currencies.js